export default __webpack_public_path__ + "static/media/integrate.25043dbf.svg";